<script setup lang="ts">
const storeIndex = useStoreIndex()

definePageMeta({ layout: 'layout-side-default' })

const app = useNuxtApp()

const setHead = () => {
  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: 'ウェブサイト利用規約',
      disabled: true,
    },
  ])

  const headInput = app.$makeMeta({
    title: '利用規約',
    description: '日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］の利用規約。美術館・博物館の情報はアイエムで！',
  })
  useHead(headInput)
}

const initPage = async () => {
  await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
  ])
}
await initPage()

setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      ウェブサイト利用規約
    </h2>

    <div class="c-content">
      <div class="c-content_item">
        <pre class="c-content_item_detailText">
          この利用規定は、インターネットミュージアム事務局（以下、「本事務局」といいます）が、このウェブサイト（以下、「本サイト」といいます）で提供するサービスの利用条件を定めるものです。<br>
          本サイトへのアクセス及び閲覧は、下記の利用規定ならびに関連法規の制約を受けることをご承知おきください。下記の利用規定に同意いただけない場合は、ご利用をお断りする場合があります。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第１条
        </div>
        <pre class="c-content_item_detailText">
          特段の合意がない限り、本サイトの著作権は、本事務局に帰属いたします。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第２条
        </div>
        <pre class="c-content_item_detailText">
          本サイト内の情報（以下「本コンテンツ」といいます）は、文書による本事務局の事前承諾がない限り、いかなる方法、目的においてもご利用（複製、頒布、改変、公衆送信、再利用及び転送等を含みます）になることはできません。本事務局の承諾なく本コンテンツをご使用になった場合、著作権法・商標法違反、肖像権・プライバシーの侵害にあたる可能性があります。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第３条
        </div>
        <pre class="c-content_item_detailText">
          利用者は、本サイトの利用に際して、以下の行為をしてはならないものとします。

          ・公序良俗または法令に反する、またはそのおそれのある行為。

          ・犯罪的行為に結びつく、またはそのおそれのある行為。

          ・本事務局、または第三者の著作権などの知的財産権、そのほかの権利を侵害する行為。

          ・他者のプライバシーを侵害する行為。

          ・本サイトまたは本事務局が提供する情報を、営利目的に使用する行為。

          ・本サイトで使用するIDおよびパスワードを不正に使用する行為。

          ・他の利用者のIDまたはパスワードを不正に使用する行為。

          ・IDまたはパスワードを第三者に譲渡または使用させる行為。

          ・有害なコンピュータプログラム、および偽装ファイルなどを送信し、または書き込む行為。

          ・他の利用者による本サイトにおける本事務局サービスまたはその一部の利用もしくはアクセスを妨げる行為。

          ・本事務局または第三者を誹謗中傷しもしくは名誉または信用を傷つけるような行為。

          ・そのほか、本サイトにおいて不適切であると本事務局が判断する行為。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第４条
        </div>
        <pre class="c-content_item_detailText">
          本事務局は、本コンテンツに関しその内容の正確性、妥当性、ご利用にあたっての適合性、安全性その他について、いかなる保証をするものではありません。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第５条
        </div>
        <pre class="c-content_item_detailText">
          本サイト、もしくは本サイトからリンクしている第三者のサイト、また本サイトへリンクしている第三者のサイトの内容に関し、その誤り及び内容に基づいて被った損害について、本事務局は一切責任を負いません。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第６条
        </div>
        <pre class="c-content_item_detailText">
          本利用規定と本サイトの利用に関しては日本国法に準拠し、本サイトに関連して発生した全ての紛争の解決手続は東京地方裁判所を第一審の専属管轄裁判所とします。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第７条
        </div>
        <pre class="c-content_item_detailText">
          本事務局は、予告無しに何時でも本コンテンツの変更・削除等を行う権限を有します。本コンテンツの変更、削除等により発生するいかなる損害に対して、本事務局は一切責任を負いません。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第８条
        </div>
        <pre class="c-content_item_detailText">
          本事務局は、本コンテンツを、業務提携事業者へ提供して公開する場合があります。なお、提供先の業務提携事業者は、日本法令の定める範囲において、業務提携事業者の定めた規約に基づき、情報解析に利用することがあります。
        </pre>
      </div>

      <div class="c-content_item">
        <div class="c-content_item_title">
          第９条
        </div>
        <pre class="c-content_item_detailText">
          本事務局は、予告無しに本利用規定を変更することがありますのでご注意ください。
        </pre>
      </div>
    </div>
    <pre class="l-regularText">

          以上

          附則
        </pre>
    <div class="l-regularText_lastLine">
      本規約は、令和2年6月24日から施行します。<br>
      本規約は、令和7年9月18日に改定しました。
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-content {
  margin-top: 28px;

  &_item {
    margin-bottom: 38px;

    @include responsive.mq_down(sp) {
      margin-bottom: 28px;
    }

    &_title {
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      font-weight: bold;

      @include responsive.mq_down(sp) {
        font-size: var(--g_fontSize_h2_sp);
      }
    }

    &_detailText {
      margin-top: 8px;
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      white-space: pre-line;

      @include responsive.mq_down(sp) {
        font-size: var(--g_fontSize_middle_sp);
      }
    }

    &_detailNumber {
      margin-top: 11px;
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;

      @include responsive.mq_down(sp) {
        font-size: var(--g_fontSize_middle_sp);
      }
    }

    &_numberOrder {
      width: 30px;
    }

    &_numberDetail {
      padding-left: 10px;
      word-break: break-all;

      &.smallPaddingLeft {
        padding-left: 0;
      }
    }
  }
}

.l-regularText {
  margin-top: -25px;
  color: var(--g_color_button_text_black);
  font-family: var(--g_font_family_NotoSansCJKjp);
  font-size: 16px;
  white-space: pre-line;

  @include responsive.mq_down(sp) {
    font-size: var(--g_fontSize_middle_sp);
  }

  &_lastLine {
    margin-left: 15px;
  }
}
</style>
